import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProfile = () => api.get("/profile").then((r) => r.data);
export const getBlogs = () => api.get("/blogs").then((r) => r.data);
export const getBlog = (slug) => api.get(`/blogs/${slug}`).then((r) => r.data);
export const getMusic = () => api.get("/music").then((r) => r.data);
export const subscribe = (email) => api.post("/subscribe", { email }).then((r) => r.data);
export const sendMessage = (payload) => api.post("/contact", payload).then((r) => r.data);
